import { $ } from '../utils/jquery.js';
import { Swiper, Navigation, Pagination, Controller } from 'swiper';

function artistPageReviewsSlider() {
  const imagesSliderSelector = ".js-artist-reviews-slider-images";
  const textsSliderSelector = ".js-artist-reviews-slider-reviews";
  const paginationSelector = ".js-artist-reviews-pagination";
  const nextButtonSelector = ".js-artist-reviews-nav-next";
  const prevButtonSelector = ".js-artist-reviews-nav-prev";

  if (
    $(imagesSliderSelector).length === 0 ||
    $(textsSliderSelector).length === 0
  ) {
    return;
  }

  const imagesSlider = new Swiper(imagesSliderSelector, {
    slidesPerView: 1,
    centeredSlides: false,
    modules: [Pagination, Controller, Navigation],
    spaceBetween: 0,
    mousewheel: {
      forceToAxis: true,
    },
  });

  const textsSlider = new Swiper(textsSliderSelector, {
    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: 0,
    modules: [Navigation, Pagination],
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: nextButtonSelector,
      prevEl: prevButtonSelector,
    },
    pagination: {
      el: paginationSelector,
      bulletClass: "artist-reviews__nav-item js-artist-review-bullet",
      bulletActiveClass: "is-active",
      clickable: true,
      renderBullet(index, className) {
        const slide = $(document).find(`.artist-reviews__review:eq(${index})`);
        const slideName = slide.data("title");
        return `<button type="button" class="${className}">${slideName}</button>`;
      },
    },
    controller: {
      control: imagesSlider,
    },
  });

  textsSlider.on("slideChange", () => {
    const pagination = $(paginationSelector);
    imagesSlider.slideTo(textsSlider.activeIndex);

    if (!pagination.length) {
      return;
    }

    const bullet = pagination.find('.js-artist-review-bullet.is-active');

    pagination[0].scrollTo(
      bullet.position().left - parseInt(pagination.css("padding-left"), 10),
      {
        behavior: "smooth",
      }
    );
  });

  imagesSlider.on("slideChange", () => {
    textsSlider.slideTo(imagesSlider.activeIndex);
  });
}

function ourClientSlider() {
  const imagesSliderSelector = ".js-our-client-bottom-slider";
  const textsSliderSelector = ".js-our-client-slider";
  const nextButtonSelector = ".js-our-client-slider-next";
  const prevButtonSelector = ".js-our-client-slider-prev";

  if (
    $(imagesSliderSelector).length === 0 ||
    $(textsSliderSelector).length === 0
  ) {
    return;
  }

  const imagesSlider = new Swiper(imagesSliderSelector, {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 70,
    modules:[Controller],
    mousewheel: {
      forceToAxis: true,
    },
    slideToClickedSlide: true,
    breakpoints: {
      1024: {
        spaceBetween: 120,
      },
    },
  });

  const textsSlider = new Swiper(textsSliderSelector, {
    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: 0,
    modules:[Navigation, Pagination, Controller],
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: nextButtonSelector,
      prevEl: prevButtonSelector,
    },
    controller: {
      control: imagesSlider,
    },
  });

  imagesSlider.controller.control = textsSlider;
}

setTimeout(artistPageReviewsSlider, 0);
setTimeout(ourClientSlider, 0);

// bottom image slider
const seeUsContentSlider = new Swiper(".see-us__content--slider", {
  slidesPerView: 3,
  centeredSlides: false,
  modules:[Navigation, Pagination],
  spaceBetween: 20,
  mousewheel: {
    forceToAxis: true,
  },
  pagination: {
    el: ".swiper-pagination",
  },
  breakpoints: {
    767: {
      slidesPerView: 3,
      spaceBetween: 30,
      pagination: false,
    },
    320: {
      slidesPerView: 2.46,
      spaceBetween: 17,
    },
  },
});

// bottom product slider
const swiperForBtmProducts = new Swiper(".artist-recent-product-slider", {
  slidesPerView: 4,
  modules:[Navigation, Pagination],
  centeredSlides: false,
  spaceBetween: 0,
  mousewheel: {
    forceToAxis: true,
  },
  navigation: {
    nextEl: ".nx-recent-viewed-product-wrap .swiper-button-next",
    prevEl: ".nx-recent-viewed-product-wrap .swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
  },
});

// a-propos logo with content slider

const brandsColabSlider = new Swiper(".brands-colab-slider-wrap__swiper", {
  centeredSlides: true,
  modules:[Navigation],
  initialSlide: 1,
  mousewheel: {
    forceToAxis: true,
  },
  navigation: {
    nextEl: ".brands-colab-slider-wrap__swiper-button-next",
    prevEl: ".brands-colab-slider-wrap__swiper-button-prev",
    disabledClass: "not-active-nav",
  },
});
const brandsColabImagesSlider = new Swiper(
  ".brand-colab-slider-images__swiper",
  {
    slidesPerView: 3,
    centeredSlides: true,
    initialSlide: 1,
    modules:[Navigation],
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".brands-colab-slider-wrap__swiper-button-next",
      prevEl: ".brands-colab-slider-wrap__swiper-button-prev",
      disabledClass: "not-active-nav",
    },
    breakpoints: {
      767: {
        spaceBetween: 100,
      },
      320: {
        spaceBetween: 75,
      },
    },
  }
);

brandsColabSlider.on("slideChange", (res) => {
  brandsColabImagesSlider.slideTo(res.realIndex);
});

brandsColabImagesSlider.on("slideChange", (res) => {
  brandsColabSlider.slideTo(res.realIndex);
});

// Our artist slider
var productSliders = $('.artists-product-slider');


const productArtistSlider = ()=>{
  let productSliders = document.querySelectorAll('.artists-product-slider');
  productSliders.forEach((slider, index)=>{
    const swiper = new Swiper(slider, {
      modules:[Navigation, Pagination],
      direction: 'horizontal',
      navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: slider.querySelector('.artists-product-slider__swiper-pagination'),
      },
    }); 
  })
}
productArtistSlider();

// Vincent-amelie bottom product slider
// const wrwBottomProductSlider = new Swiper(document.querySelector('.product-grid__container'), {
//   slidesPerView: 1.5,
//   centeredSlides: true,
//   spaceBetween: 0,
//   mousewheel: true,
//   modules: [Navigation],
//   mousewheel: {
//     forceToAxis: true,
//   },
//   breakpoints: {
//     767: {
//       slidesPerView: 4,
//       centeredSlides: false,
//     },
//   },
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
// });

// Recent product slider
var ourArtistSwiper = new Swiper(".js-recent-viewed-products-slider", {
  modules: [Navigation],
  mousewheel: {
    forceToAxis: true,
  },
  navigation: {
    nextEl: ".swiper-button-next-recent",
    prevEl: ".swiper-button-prev-recent",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
      allowTouchMove: true,
      spaceBetween: 0,
    },
    1024: {
      slidesPerView: 4,
      allowTouchMove: false,
    },
  },
});
